import React from "react";
import "./home.css"; // Import the CSS file
import Faq from "react-faq-component";

const HomeSecEight = () => {
  const data = {
    rows: [
      {
        title: "What is Riley's Alert and how does it work?",
        content: `<p>Riley's Alert is your personal safety companion, designed to keep you connected and protected when it matters most.</p>
<p>With just one tap, the app instantly notifies your designated contacts via SMS, sharing your real-time GPS location and alerting them to your situation.</p>
<p>The app also activates an audio/video recording feature, capturing and securely storing crucial evidence off-site to enhance safety, transparency, and accountability.</p>`,
      },
      {
        title: "How does the audio/video recording feature work?",
        content: `<p>When you activate Riley's Alert, the app immediately starts recording audio and video to document events in real time.</p>
<p>These recordings are securely stored off-site, ensuring valuable evidence is preserved and accessible when needed.</p>
<p>The feature is only activated when you press the alert button, providing a reliable safety net without continuous background recording.</p>`,
      },
      {
        title: "How does Riley's Alert enhance my personal safety?",
        content: `<p>Riley's Alert ensures instant connectivity with your trusted contacts during urgent situations.</p>
<p>By combining real-time GPS location sharing, instant alerts, and on-demand recording, the app empowers you with a direct link to support when you need it most.</p>
<p>Whether you're in distress, facing uncertainty, or need to share an urgent update, Riley's Alert keeps you connected and in control.</p>`,
      },
      {
        title: "Who can use Riley's Alert?",
        content: `<p>Riley's Alert is designed for anyone who values personal safety and staying connected in critical moments.</p>
<p>Whether you're a student, working professional, parent, senior, solo traveler, or community member, the app provides peace of mind by ensuring your loved ones are informed and ready to respond.</p>`,
      },
      {
        title:
          "Is my personal data, including location information and recordings, secure?",
        content: `<p>Absolutely. Riley's Alert prioritizes privacy and security by using secure servers and industry-standard encryption protocols to protect your personal information, location data, and recorded content.</p>
<p>You remain in full control of who receives your alerts, and your data is never shared without your consent.</p>`,
      },
      {
        title: "What if I accidentally trigger an alert?",
        content: `<p>Riley's Alert includes a built-in confirmation step to prevent accidental activations.</p>
<p>If an alert is triggered by mistake, you'll have the option to cancel before any notifications are sent.</p>
<p>This ensures your trusted contacts are only notified when you truly need assistance.</p>`,
      },
      {
        title: "How do I manage my emergency contacts?",
        content: `<p>Managing your trusted contacts is simple.</p>
<p>Navigate to the "Contacts" section in the app to add, edit, or remove emergency contacts at any time.</p>
<p>Keeping this list updated ensures that your support network is always ready to respond when needed.</p>`,
      },
      {
        title:
          "What should I do if I experience a technical issue with the app?",
        content: `<p>If you encounter any technical issues or have questions about using Riley's Alert, our support team is here to help.</p>
<p>Contact us at info@rileysalert.com, and we'll ensure your experience remains seamless, reliable, and stress-free.</p>`,
      },
    ],
  };
  const styles = {
    rowTitleColor: "black",
    rowContentColor: "black",
    rowContentTextSize: 18,
    rowTitleTextSize: 22,
  };
  const config = {
    animate: true,
    expandIcon: "+",
    collapseIcon: "_",
  };
  return (
    <div className="home-sec-five">
      <div className="sec7MainContainer">
        <div className="faq-text-container">
          <p className="faq-title">FAQ's</p>
          <p className="faq-text">
            Explore the frequently asked questions those may answer your
            queries.
          </p>
        </div>
        <Faq data={data} styles={styles} config={config} />
      </div>
    </div>
  );
};

export default HomeSecEight;
